import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { EventLoader } from 'src/domains/sportsbook/webview/components/loaders/EventLoader';
import {
    EventsLoaderWrapper,
    EventsTableSportLoaderWrapper,
    FiltersLoader,
    SecondaryHeaderLoader,
} from 'src/domains/layouts/shared/loaders';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

export const EventsTableSportLoader = observer('EventsTableSportLoader', (): JSX.Element => {
    const common = useCommon();
    const configState = ConfigComponents.get(common).config;
    const { sportsbookVariant } = configState.componentVariants;
    const threeEventRows = [];
    const twoEventRows = [];

    for (let i = 0; i < 3; i++) {
        threeEventRows.push(<EventLoader key={i} />);
    }

    for (let i = 0; i < 2; i++) {
        twoEventRows.push(<EventLoader key={i} />);
    }

    return (
        <EventsTableSportLoaderWrapper variant={sportsbookVariant}>
            <SecondaryHeaderLoader
                variant={sportsbookVariant}
                size='sportsFilters'
            />
            <FiltersLoader />
            <SecondaryHeaderLoader
                variant={sportsbookVariant}
                size='small'
            />
            <EventsLoaderWrapper variant={sportsbookVariant}>{threeEventRows}</EventsLoaderWrapper>
            <SecondaryHeaderLoader
                variant={sportsbookVariant}
                size='small'
            />
            <EventsLoaderWrapper variant={sportsbookVariant}>{threeEventRows}</EventsLoaderWrapper>
            <SecondaryHeaderLoader
                variant={sportsbookVariant}
                size='small'
            />
            <EventsLoaderWrapper variant={sportsbookVariant}>{twoEventRows}</EventsLoaderWrapper>
            <SecondaryHeaderLoader
                variant={sportsbookVariant}
                size='small'
            />
            <EventsLoaderWrapper variant={sportsbookVariant}>{twoEventRows}</EventsLoaderWrapper>
        </EventsTableSportLoaderWrapper>
    );
});
